import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Multiple scroll methods for maximum compatibility across all browsers
    // especially iOS Safari which can be problematic
    
    // Method 1: Standard window.scrollTo
    window.scrollTo(0, 0);
    
    // Method 2: Direct DOM manipulation (iOS Safari fallback)
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    
    // Method 3: Force immediate scroll with options object
    // Using 'auto' instead of 'instant' for better iOS compatibility
    try {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "auto"
      });
    } catch (error) {
      // Fallback for older browsers
      window.scrollTo(0, 0);
    }
    
    // Method 4: Delayed scroll for iOS Safari (sometimes needs a small delay)
    // This ensures scroll happens after any animations/transitions
    const timeoutId = setTimeout(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 0);
    
    return () => clearTimeout(timeoutId);
  }, [pathname]);

  return null;
};

export default ScrollToTop;

